import React, { useState, useEffect } from 'react';
import { Play, Youtube, AlertCircle } from 'lucide-react';

const WatchLive = () => {
  const [isLive, setIsLive] = useState(false);
  const [liveStreamData, setLiveStreamData] = useState(null);

  // Mock: Simulate checking for live stream
  useEffect(() => {
    // In real implementation, this will call backend API to check YouTube live status
    const checkLiveStatus = () => {
      // Mock data - will be replaced with real API call
      setIsLive(false);
      setLiveStreamData(null);
    };

    checkLiveStatus();
    const interval = setInterval(checkLiveStatus, 60000); // Check every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="page-container watch-live-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="page-hero-bg" 
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1667068114508-0055f7fb25a3?w=1920)' }}
        >
          <div className="page-hero-overlay" />
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Watch Live</h1>
          <p className="page-hero-subtitle">
            Join us for live worship and teaching from anywhere in the world
          </p>
        </div>
      </section>

      {/* Live Stream Section */}
      <section className="content-section">
        <div className="container">
          <div className="live-stream-container">
            {isLive && liveStreamData ? (
              /* Live Stream Active */
              <div className="live-player">
                <div className="live-badge">
                  <span className="live-dot"></span>
                  LIVE NOW
                </div>
                <div className="video-player">
                  <div className="video-placeholder">
                    <Play size={64} />
                    <p>Live stream player will load here</p>
                  </div>
                </div>
                <div className="live-info">
                  <h2>{liveStreamData?.title || "Sunday Service"}</h2>
                  <p>{liveStreamData?.description || "Join us for worship and teaching"}</p>
                </div>
              </div>
            ) : (
              /* No Live Stream */
              <div className="no-live-stream">
                <div className="no-live-icon">
                  <Youtube size={64} />
                </div>
                <h2>We're Not Live Right Now</h2>
                <p>
                  We'll be streaming our next service soon. In the meantime, check out our 
                  previous sermons or subscribe to get notified when we go live.
                </p>
                <div className="no-live-actions">
                  <a 
                    href="/sermons" 
                    className="btn btn-primary"
                  >
                    Watch Recent Sermons
                  </a>
                  <a 
                    href="https://www.youtube.com/@UnitedChristianFellowship0" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                  >
                    Subscribe on YouTube
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* Service Times */}
          <div className="service-times-section">
            <h3>Regular Service Times</h3>
            <div className="service-times-grid">
              <div className="service-time-card">
                <h4>Sunday Service</h4>
                <p className="time">10:00 AM MST</p>
                <p className="note">Join us for worship and teaching</p>
              </div>
              <div className="service-time-card">
                <h4>Prayer Meeting</h4>
                <p className="time">Wednesday 7:00 PM MST</p>
                <p className="note">Corporate prayer and intercession</p>
              </div>
              <div className="service-time-card">
                <h4>Special Events</h4>
                <p className="time">Check Events Page</p>
                <p className="note">Conferences, festivals, and gatherings</p>
              </div>
            </div>
          </div>

          {/* Info Notice */}
          <div className="info-notice">
            <AlertCircle size={24} />
            <div>
              <h4>Technical Requirements</h4>
              <p>
                For the best viewing experience, we recommend using a modern web browser with a stable 
                internet connection. The live stream will automatically detect and adjust quality based 
                on your connection speed.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WatchLive;
